export const ADDRESS_MODAL_WIDTH_DESKTOP = '600px';
